// Module
var code = "<div class=\"failed-validation\"><div ng-bind-html=\"formattedMessage\"></div><button ng-click=\"dismiss()\" name=\"dismiss\" class=\"modal-action-button\">{{::buttonText}}</button></div>";
// Exports
export default code;